// @flow
import { SET_TOKEN_ID } from './actionTypes';
import type { Dispatch } from 'types/redux';
import type { State as StoreState } from 'store/State';

// Actions
import { setPrivateRoute } from 'store/reducers/userInteractions/actions';
import { getDealerData } from 'store/reducers/dealerData/actions';

// Selectors
import { getDealerDataParams } from 'store/reducers/dealerData/selectors';

export function setTokenId(tokenId: string) {
  return {
    type: SET_TOKEN_ID,
    payload: tokenId
  };
}

export const generateTokenId = () => async (
  dispatch: Dispatch,
  getState: () => StoreState
) => {
  setPrivateRoute(false);
  const params = getDealerDataParams()(getState());
  const { tokenId } = await dispatch(getDealerData(params));
  if (tokenId) {
    dispatch(setTokenId(tokenId));
    dispatch(setPrivateRoute(true));
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/tokenId/actions.js